<div data-testid="roles-list-page" class="roles-container h-full pt-4 px-4">
  <!-- Header for entire screen -->
  <div class="p-2">
    <h2 class="text-2xl font-semibold text-gray-800">
      {{ "configuration.roles.management.title" | translate }}
    </h2>
  </div>

  <!-- Loading Overlay for Operations -->
  <div *ngIf="deleteLoading() || statusUpdateLoading()" class="loading-overlay">
    <div class="loading-content">
      <div class="flex items-center space-x-3">
        <div
          data-testid="roles-list-loading"
          class="loading-spinner rounded-full h-8 w-8 border-b-2 border-blue-600"
        ></div>
        <div class="loading-text">
          <span *ngIf="deleteLoading()">{{
            "configuration.roles.loading.deleting_roles" | translate
          }}</span>
          <span *ngIf="statusUpdateLoading()">{{
            "configuration.roles.loading.updating_status" | translate
          }}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="flex main-container h-full">
    <!-- Left Sidebar - Roles Tree -->
    <div class="flex-left">
      <app-roles-sidebar
        data-testid="roles-list-sidebar"
        [canCreate]="canCreate()"
        [canDelete]="canDelete()"
        [clearSelection]="clearSidebarSelection()"
        (deleteRoleRequest)="onSidebarDelete($any($event))"
      ></app-roles-sidebar>
    </div>

    <!-- Right Content Area -->
    <div class="flex-right">
      <app-search-form
        data-testid="roles-list-permission-search-form"
        class="permission-toolbar mb-4"
        [searchFormat]="permissionSearchConfig"
        (formSearch)="onPermissionSearch($event)"
        (formReset)="onPermissionReset()"
      >
        <div slot="actions">
          <app-button
            [testId]="'roles-list-save-permissions-btn'"
            type="info"
            label="common.actions.save"
            [disabled]="!hasSelectedRole() || !canUpdate()"
            (emitOnClick)="permissionTree.onSave()"
          ></app-button>
        </div>
      </app-search-form>

      <div
        class="permission-tree-container"
        [class.pointer-events-none]="!hasSelectedRole()"
        [class.opacity-60]="!hasSelectedRole()"
      >
        <app-permission-tree
          data-testid="roles-list-permission-tree"
          #permissionTree
          [readOnly]="!canUpdate()"
          [searchTerm]="permissionSearchTerm()"
          [selectedMenuCodes]="selectedRoleMenuCodes()"
          (savePermissions)="onSavePermissions($event)"
        ></app-permission-tree>
      </div>
    </div>
  </div>

  <!-- Toast Messages -->
  <p-toast data-testid="roles-list-toast"></p-toast>

  <!-- Delete Role Confirmation Dialog -->
  <app-confirmation-dialog
    data-testid="roles-list-delete-confirmation-dialog"
    [(visible)]="showConfirmationDialog"
    [title]="dialogTitle"
    [hasCustomContent]="false"
    [buttons]="dialogButtons"
    (emitOnClick)="onDeleteRoleDialogAction($event)"
    [message]="getDeleteRoleMessage()"
  ></app-confirmation-dialog>
</div>
